export const METRICS_WHITELIST = 'metrics.email.whitelist';
export const METRICS_IFRAME_URL = 'metrics.iframe.url';
